export const StringConstants = {
  EMPTY: '',
  ZERO: '0',
  ONE: '1',
  ZERO_WITH_TWO_DECIMALS: '0.00',
  NOT_AVAILABLE: 'N/A',
  UNDEFINED: 'undefined',
  EMPTY_HEX: '0x',
  W: 'W',
  DOT: '.',
  ZERO_DOT: '0.',
  ZERO_DOT_ZERO: '0.0',
  PERCENT: '%',
  DOUBLE_HYPHEN: '--',
  ZERO_DOLLAR_VALUE: '$0.00',
  SPACE: ' ',
  TILDE: '~',
  PLUS: '+',
  MINUS: '−',
  DOLLAR: '$',
};
